import React from 'react';
import { countryConstants, professionConstants, genreConstants } from '../../../wm_constants/index';
import '../editProfile.css';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class PatchProfile extends React.Component {
    state={
        country: '',
        profession: "",
        genre: "",
        name: "",
        prof: ''
    }
    static propTypes = {
        id: PropTypes.string,
        users: PropTypes.string
    }
    onChange = e => {this.setState({
        [e.target.name]: e.target.value
    });
    console.log(e.target.name + ' : ' + e.target.value)
    console.log(this.props.id)
    };
    onSubmit = e => {
        e.preventDefault();
        console.log('Submitted')
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${this.props.id}`
            }
        };
        const user = this.props.users
        const body = JSON.stringify({ name : this.state.name, country: this.state.country, profession: [this.state.profession, this.state.prof] })
        axios.patch(user, body, config)
            .then(res => {
                console.log(res)
            })
            .catch(err => {
        })
        console.log(user,body,config)
    }
    render() {
        const {country, name, profession, genre, prof} = this.state
        return(
            <div id='editProfileWrapper'>
                <form id='editProfileForm'>
                    <p>Full Name</p>
                    <input value={name} name='name' onChange={this.onChange} placeholder='Your Name' />
                    <p>Country of Residence</p>
                    <select className="form-control" name="country" type='choice' value={country} onChange={this.onChange}
                        id="countryConstants">
                        <option value="">Select country</option>
                        {countryConstants.map(k => <option value={k.id}>{k.name}</option>)}
                    </select>
                    <p>Primary Profession</p>
                    <select className="form-control" name="profession" type='choice' value={profession} onChange={this.onChange}
                        id="professionConstants">
                        <option value="">Select Profession</option>
                        {professionConstants.map(k => <option value={k.id}>{k.name}</option>)}
                    </select>
                    <p>Secondary Profession</p>
                    <select className="form-control" name="prof" type='choice' value={prof} onChange={this.onChange}
                        id="professionConstants">
                        <option value="">Select Second Profession</option>
                        {professionConstants.map(k => <option value={k.id}>{k.name}</option>)}
                    </select>
                    <p>Genre</p>
                    <select className="form-control" name="genre" type='choice' value={genre} onChange={this.onChange}
                        id="genreConstants">
                        <option value="">Select Genre</option>
                        {genreConstants.map(k => <option value={k.id}>{k.name}</option>)}
                    </select>
                    <div id='edit-btn-wrapper' className="editProBtn">
                        <button onClick={this.onSubmit}>Submit</button>
                    </div>
                </form>
            </div>
        )
    }
}
const mapStateToProps = state => ({
    id: state.auth.key,
    users: state.auth.users
})
export default connect(mapStateToProps)(PatchProfile)